import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';

// Import your page components
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Achievements from './pages/Achievements';
import SpecialSchool from './pages/SpecialSchool';
import Workshop from './pages/Workshop';
import Media from './pages/Media';
import Committee from './pages/Committee';
import ContactUs from './pages/ContactUs';
import Donate from './pages/Donate';
import AnnualReport from './pages/AnnualReportPage';
import Footer from './components/Footer';
import GalleryPage from './pages/GalleryPage';
import VideoGalleryPage from './pages/VideoGalleryPage';
import CertificatesPage from './pages/CertificatesPage'; // <--- Import the new Footer component

function App() {
  return (
    <BrowserRouter> {/* Wrap your entire application with BrowserRouter */}
      <Header /> {/* The Header component will be rendered on all pages */}
      
      <Routes> {/* Define your routes inside the Routes component */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/special-school" element={<SpecialSchool />} />
        <Route path="/workshop" element={<Workshop />} />
        <Route path="/media" element={<Media />} />
        <Route path="/committee" element={<Committee />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/donate" element={<Donate />} /> 
        <Route path="/annual-report" element={<AnnualReport />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/video-gallery" element={<VideoGalleryPage />} />
        <Route path="/certificates" element={<CertificatesPage />} />
        {/* Add more routes for other pages */}
      </Routes>

      <Footer /> {/* <--- Render the Footer component here */}
    </BrowserRouter>
  );
}

export default App;